import React, { useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { usePermission } from '@tomfxs/permissions-client'

import loadComponent from 'src/utils/loadMFE'
import RouteContainer from 'src/components/App/RouteContainer'

const QuestionPoolUpdateForm = React.lazy(() => loadComponent('mfeedback', 'QuestionPoolUpdateForm'))

export function QuestionPoolDetailsRoute() {
    const params = useParams()
    const navigate = useNavigate()

    const canUpdate = usePermission('feedback.questionPool.update', {})
    const canDelete = usePermission('feedback.questionPool.delete', {})

    const onDelete = useCallback(() => {
        navigate('/marah-feedback/question_pools')
    }, [navigate])

    const onUpdate = useCallback(() => {
        navigate('/marah-feedback/question_pools')
    }, [navigate])

    return (
        <RouteContainer>
            <QuestionPoolUpdateForm _id={params._id} canDelete={canDelete} canUpdate={canUpdate} onDelete={onDelete} onUpdate={onUpdate} />
        </RouteContainer>
    )
}
